import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { QueryParameters, Routes } from "@lifeat/shared/system/RouteConstants";
import { calculateIncompleteOnboardingStep } from "@lifeat/shared/user/UserUtil";
import { useUserContext } from "@contexts/UserContext";
import { buildRoute } from "@util/RouteUtil";
import { RouteUtil } from "@util/index";

export function OnboardingVisibilityController() {
    const history = useHistory();
    const { user, userData, loading } = useUserContext();

    // if user hasn't completed onboarding or free trial, redirect
    const bypassOnboarding = Boolean(RouteUtil.getQueryParamValue(QueryParameters.BypassOnboarding));
    useEffect(() => {
        if (!loading) {
            if (user == null || userData == null) {
                // Unauthenticated users should not be redirected.
                return;
            }
            if (!user.emailVerified) {
                // Unverified users should finish email verification first.
                history.push(buildRoute(Routes.DesktopMain));
                return;
            }

            const incompleteOnboardingStep = calculateIncompleteOnboardingStep(userData, bypassOnboarding);

            switch (incompleteOnboardingStep) {
                case "survey":
                case "upgrade":
                    history.push(buildRoute(Routes.Signup));
                    return;
                case "video":
                    history.push(buildRoute(Routes.OnboardingVideo));
                    return;
                case "none":
                    return;
            }
        }
    });

    return null;
}
